<template>
    <div>
        <div v-if="!isMobile">
            <div v-if="!bannerStore.ready" class="skeleton w-full">
                <div style="width: 100%; padding-top: calc(100% / 3.2);"></div>
            </div>
            <div v-if="bannerStore.ready && banners.length > 0" ref="sliderLazy" class="relative overflow-hidden">
                <LazyCardSlider v-if="shouldRenderSlider" :cards="banners" v-model="slide" :config="{maxDegree: 0, cardDistance: 0, maxScale: 0}" :aspectStyle="3.2">
                    <template #default="{ card, shouldLoad }">
                        <div @click="goBannerURL(card.link)" class="relative overflow-hidden" :class="card.link ? 'cursor-pointer' : ''">
                            <div style="width: 100%; padding-top: calc(100% / 3.2);"></div>
                            <img v-if="shouldLoad" class="pointer-events-none w-full absolute top-0 left-0" :key="card.id" :src="card.desktop_img" :alt="`banner_${card.id}`"/>
                        </div>
                    </template>
                </LazyCardSlider>
            </div>
            <div ref="marqueeAnnounceLazy">
                <LazyMerchantMarqueeAnnounce v-if="shouldRenderMarqueeAnnounce"></LazyMerchantMarqueeAnnounce>
            </div>
            
            <div class="container">
                <MerchantHomeGameContainer type="slot"></MerchantHomeGameContainer>
                <ClientOnly v-if="tutorialSliderDisplay">
                    <div class="m-5 flex justify-center">
                        <div class="md:w-[95%] 2xl:w-[80%] overflow-hidden rounded-2xl">
                            <TutorialSlider/>
                        </div>
                    </div>
                </ClientOnly>
            </div>
        </div>
        <div ref="freeCreditFloatLazy">
            <LazyFreeCreditFloat v-if="shouldRenderFreeCreditFloat" />
        </div>
        <!-- game container 100px is topbar 50px and 50px bottom nav menu -->
        <div v-if="isMobile">
            <div class="flex flex-col" :style="`${homeHeight != 0 ? `height: calc(${homeHeight}px - ${mainStore.appBannerDisplay ? `${config.public.GAME_LICENSE ? '158px' : '160px'}` : `${config.public.GAME_LICENSE ? '98px' : '100px'}`})` : ''}`"> 
                <div class="relative shrink-0">
                    <div v-if="!bannerStore.ready" class="skeleton w-full">
                        <div style="width: 100%; padding-top: calc(100% / 3.2);"></div>
                    </div>
                    <div v-if="bannerStore.ready && banners.length > 0" ref="sliderLazy2" class="w-full overflow-hidden">
                        <LazyCardSlider v-if="shouldRenderSlider2" :cards="banners" v-model="slide" :config="{maxDegree: 0, cardDistance: 0, maxScale: 0}" :aspectStyle="3.2">
                            <template #default="{ card, shouldLoad }">
                                <div @click="goBannerURL(card.link)" class="relative overflow-hidden" :class="card.link ? 'cursor-pointer' : ''">
                                    <div style="width: 100%; padding-top: calc(100% / 3.2);"></div>
                                    <img v-if="shouldLoad" class="pointer-events-none w-full absolute top-0 left-0" :key="card.id" :src="card.mobile_img" :alt="`banner_${card.id}`"/>
                                </div>
                            </template>
                        </LazyCardSlider>
                    </div>
                    <HomeMarqueeAnnounceMobile></HomeMarqueeAnnounceMobile>
                    <div class="px-[10px] flex items-center justify-between header-menu-mobile">
                        <div class="flex justify-center items-center w-full">
                            <div v-if="shouldShowButton" class="w-1/4 relative flex items-center justify-center">
                                <button :aria-label="$t('referral')" @click="goPage('referral')" type="button" class="text-center">
                                    <div class="inhouse_home_menu_button">
                                        <img v-if="config.public.MENU_ICON_TYPE == '2'" class="w-[20px] mx-auto" :ref="collectLazyImage" :data-src="$pub(`/img/icons_svg/icon-h5_menu_referral.webp`)" :alt="`icon-referral`">
                                        <Icon v-else iconClass="icon-h5-menu-referral"></Icon>
                                    </div>
                                    <img class="w-[30px] mx-auto outhouse_home_menu_button" :ref="collectLazyImage" :data-src="$pub('/img/icons/merchant_home/icon_mobile_referral.webp')" alt="referral">
                                    <div class="text-[12px] quick-access-text mx-auto">{{$t("referral")}}</div>
                                </button>
                            </div>
    
                            <div v-else-if="downloadDisplay && (androidDisplaySetting || iosDisplaySetting)" class="w-1/4 relative flex items-center justify-center">
                                <NuxtLink v-if="(isAndroid && androidDisplaySetting) || (isIos && iosDisplaySetting)" :to="localePath('/app')" class="text-center" :aria-label="$t('app')">
                                    <div class="inhouse_home_menu_button">
                                        <img v-if="config.public.MENU_ICON_TYPE == '2'" class="w-[20px] mx-auto" :ref="collectLazyImage" :data-src="$pub(`/img/icons_svg/icon-h5_menu_app.webp`)" :alt="`icon-app`">
                                        <Icon v-else iconClass="icon-h5-menu-app"></Icon>
                                    </div>
                                    <img class="w-[30px] mx-auto outhouse_home_menu_button" :ref="collectLazyImage" :data-src="$pub('/img/icons/merchant_home/icon_mobile_download.webp')" alt="download">
                                    <div class="text-[12px] quick-access-text mx-auto">{{$t("app")}}</div>
                                </NuxtLink>
                                <button v-if="isIos && !iosDisplaySetting" @click="mainStore.iosModal = true" :aria-label="$t('app')" type="button" class="text-center">
                                    <div class="inhouse_home_menu_button">
                                        <img v-if="config.public.MENU_ICON_TYPE == '2'" class="w-[20px] mx-auto" :ref="collectLazyImage" :data-src="$pub(`/img/icons_svg/icon-h5_menu_app.webp`)" :alt="`icon-app`">
                                        <Icon v-else iconClass="icon-h5-menu-app"></Icon>
                                    </div>
                                    <img class="w-[30px] mx-auto outhouse_home_menu_button" :ref="collectLazyImage" :data-src="$pub('/img/icons/merchant_home/icon_mobile_download.webp')" alt="download">
                                    <div class="text-[12px] quick-access-text mx-auto">{{$t("app")}}</div>
                                </button>
                            </div>
                            <div class="w-1/4 relative flex items-center justify-center">
                                <button @click="goPage('deposit')" v-track="'deposit_btn_3'" type="button" :aria-label="$t('deposit')" class="text-center">
                                    <div class="inhouse_home_menu_button">
                                        <img v-if="config.public.MENU_ICON_TYPE == '2'" class="w-[20px] mx-auto" :ref="collectLazyImage" :data-src="$pub(`/img/icons_svg/icon-h5_menu_deposit.webp`)" :alt="`icon-deposit`">
                                        <Icon v-else iconClass="icon-h5-menu-deposit"></Icon>
                                    </div>
                                    <img class="w-[30px] mx-auto outhouse_home_menu_button" :ref="collectLazyImage" :data-src="$pub('/img/icons/merchant_home/icon_mobile_deposit.webp')" alt="deposit">
                                    <div class="text-[12px] quick-access-text mx-auto">{{$t("deposit")}}</div>
                                </button>
                            </div>
                            <div class="w-1/4 relative flex items-center justify-center">
                                <button @click="goPage('withdrawal')" type="button" class="" :aria-label="$t('withdraw')">
                                    <div class="inhouse_home_menu_button">
                                        <img v-if="config.public.MENU_ICON_TYPE == '2'" class="w-[20px] mx-auto" :ref="collectLazyImage" :data-src="$pub(`/img/icons_svg/icon-h5_menu_withdraw.webp`)" :alt="`icon-withdrawa`">
                                        <Icon v-else iconClass="icon-h5-menu-withdraw"></Icon>
                                    </div>
                                    <img class="w-[30px] mx-auto outhouse_home_menu_button" :ref="collectLazyImage" :data-src="$pub('/img/icons/merchant_home/icon_mobile_withdraw.webp')" alt="withdrawal">
                                    <div class="text-[12px] quick-access-text mx-auto">{{$t("withdraw")}}</div>
                                </button>
                            </div>
                            <div v-if="dashboardStore.data && dashboardStore.data.currency == 'NPR'" class="w-1/4 relative flex items-center justify-center">
                                <button @click="goPage('mission-diary')" :aria-label="$t('mission_diary')" v-track="'deposit_btn_3'" type="button" class="text-center">
                                    <div class="inhouse_home_menu_button">
                                        <img v-if="config.public.MENU_ICON_TYPE == '2'" class="w-[20px] mx-auto" :ref="collectLazyImage" :data-src="$pub(`/img/icons_svg/icon-h5_menu_mission_diary.webp`)" :alt="`icon-mission-diary`">
                                        <Icon v-else iconClass="icon-h5-menu-deposit"></Icon>
                                    </div>
                                    <img class="w-[30px] mx-auto outhouse_home_menu_button" :ref="collectLazyImage" :data-src="$pub('/img/icons/merchant_home/icon_mobile_mission_diary.webp')" alt="mission-diary">
                                    <div class="text-[12px] quick-access-text mx-auto">{{$t("mission_diary")}}</div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <MerchantHomeGameContainerMobile :category="category"></MerchantHomeGameContainerMobile>
            </div>
            <ClientOnly v-if="tutorialSliderDisplay">
                <div class="px-[5px] my-[10px]">
                    <div class="overflow-hidden rounded-2xl">
                        <TutorialSlider/>
                    </div>
                </div>
            </ClientOnly>
            <div ref="footerMobileLazy">
                <LazyMerchantFooterMobile v-if="shouldRenderFooterMobileLazy"/>
            </div>
        </div>
        <MerchantPartnershipSideButton v-if="PartnerMenu"/>
        <MerchantQuickLaunch />
        <AffiliateBanner />
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const props = defineProps({
    category: String
});
const dashboardStore = useDashboardStore();
const { isMobile, isIos, isAndroid } = useDevice();
const mainStore = useMainStore();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();
const localePath = useLocalePath();
const { locale, locales } = useI18n()
const { $pub, $imgLazyLoading, $elLazyLoading } = useNuxtApp()

const lazyImage = ref([])
const collectLazyImage = (el) => {
    if (el && !lazyImage.value.includes(el)) {
        lazyImage.value.push(el)
    }
}
let lazyLoader = null

//Lazy Loading for images
const imageLoader = () => {
    lazyLoader = $imgLazyLoading(lazyImage.value, {
        rootMargin: '50px',
        threshold: 0.01
    })
};

onMounted(() => {
    nextTick(() => {
        imageLoader()
    })
})

onBeforeUnmount(() => {
    if (lazyLoader) {
        lazyLoader.cleanup()
    }
})

watch(() => lazyImage.value, () => {
    nextTick(() => {
        if (lazyLoader) {
            lazyLoader.update()
        } else {
            imageLoader()
        }
    })
}, { deep: true })

//Lazy Loading for component
const useLazyElement = (options = {}) => {
    const trigger = ref(null)
    const shouldRender = ref(false)

    watch(() => trigger.value, (newVal) => {
        if (newVal) {
            $elLazyLoading(trigger, () => {
                shouldRender.value = true
            }, {
                rootMargin: '200px',
                threshold: 0.01,
                ...options
            })
        }
    }, { immediate: true })

    return { trigger, shouldRender }
}

const { trigger: sliderLazy, shouldRender: shouldRenderSlider } = useLazyElement()
const { trigger: sliderLazy2, shouldRender: shouldRenderSlider2 } = useLazyElement()
const { trigger: marqueeAnnounceLazy, shouldRender: shouldRenderMarqueeAnnounce } = useLazyElement()
const { trigger: freeCreditFloatLazy, shouldRender: shouldRenderFreeCreditFloat } = useLazyElement()
const { trigger: footerMobileLazy, shouldRender: shouldRenderFooterMobileLazy } = useLazyElement()

const partnershipStore = usePartnershipStore();
const PartnerMenu = computed(() => {
    if (dashboardStore.ready && dashboardStore.data && dashboardStore.data.currency && partnershipStore.ready && partnershipStore.settings && partnershipStore.settings[dashboardStore.data.currency] && partnershipStore.settings[dashboardStore.data.currency].display_sidemenu !== null) {
        return partnershipStore.settings[dashboardStore.data.currency].display_sidemenu
    } else {
        return null;
    }
})
// const FRTicket8177 = !['production'].includes(config.public.ENV)
const homeHeight = ref(0);
const downloadDisplay = ref(false);
onMounted(() => {
    if (route.query.app || window.localStorage.getItem('isAPP')) {
        window.localStorage.setItem("isAPP", true);
        downloadDisplay.value = false;
    } else {
        var standalone = window.navigator.standalone;
        var userAgent = window.navigator.userAgent.toLowerCase();
        var safari = /safari/.test(userAgent);

        if (isIos) {
            if (standalone) {
                downloadDisplay.value = false;
            } else if (!standalone && safari) {
                // Safari
                downloadDisplay.value = true;
            } else if (!standalone && !safari) {
                // iOS webview
                downloadDisplay.value = true;
            }
        } else {
            if (userAgent.includes('wv')) {
                if (userAgent.includes('mozilla/5.0 (linux; android 12; v2131; wv) applewebkit/537.36 (khtml, like gecko) version/4.0 chrome/87.0.4280.141 mobile safari/537.36') || userAgent.includes('vivo')) {
                    //For stupid vivo browser
                    downloadDisplay.value = true;
                } else {
                    // Android webview
                    downloadDisplay.value = false;
                }
            } else {
                // Chrome
                downloadDisplay.value = true;
            }
        };
    }

    if (isMobile && route.params.provider) {
        router.replace(localePath('/'));
    } else if (!isMobile && route.params.category) {
        router.replace(localePath('/'));
    }
    
    setTimeout(() => {
        homeHeight.value = window.innerHeight;
    }, 150)
    
})

// FPT 2898 
const shouldShowButton = computed(() => {
  return true
})


const slide = ref(0);
const bannerStore = useBannerStore()
const banners = computed(() => {
    if (!bannerStore.ready) return []
    var bannerList = [];
    if (bannerStore.data?.[locale.value]?.home) {
        var bannerPath = isMobile ? 'mobile_img' : 'desktop_img';
        for (let i = 0; i < bannerStore.data[locale.value].home.length; i++) {
            if (bannerStore.data[locale.value].home[i][bannerPath]) {
                bannerList.push(bannerStore.data[locale.value].home[i]);
            }
        }
    }
    return bannerList;
})
const goBannerURL = (url) => {
    if (typeof url != 'string') {
        return
    }
    const now = Date.now()
    if (url.indexOf('?') > - 1) {
        url += `&qt=${now}`
    }
    else {
        url += `?qt=${now}`
    }
    if (url.indexOf('http') > -1) {
        window.open(url, '_blank');
    } else {
        window.open(`${window.location.origin}${url}`, '_blank');
    }
}

const goPage = (e) => {
	if (userStore.loggedIn || e == 'referral') {
		router.push(localePath(e))
	} else {
		mainStore.loginModal = true;
	}
}

//get balance
const processedBal = computed(() => {
    if(userStore.wallet) {
        return userStore.wallet.balance
    }
})

watch(() => dashboardStore.callNumber, () => {
    if (dashboardStore.data) {
        var is_popup_flag = "0";
        if (dashboardStore.data.announce) {
            for (let i = 0; i < dashboardStore.data.announce.length; i++) {
                if (dashboardStore.data.announce[i].is_popup == '1') {
                    is_popup_flag = "1"
                }
            }
        }
        if (is_popup_flag == "1" || (dashboardStore.data.advertisement && dashboardStore.data.advertisement.length > 0)) {
            var getAnnouncementShow = window.localStorage.getItem('dontShowAnnouncement');
            if (getAnnouncementShow) {
                mainStore.announcementModal = false;
            } else {
                mainStore.announcementModal = true;
            }
        } else {
            mainStore.announcementModal = false;
        }
    }
})

const androidDisplaySetting = computed(() => {
    if (config.public.DOWNLOAD_URL_ANDROID && config.public.DOWNLOAD_URL_ANDROID[locale.value.split('-')[1]]) {
        return config.public.DOWNLOAD_URL_ANDROID[locale.value.split('-')[1]];
    }
    return "";
})

const iosDisplaySetting = computed(() => {
    if (config.public.DOWNLOAD_URL_IOS && config.public.DOWNLOAD_URL_IOS[locale.value.split('-')[1]]) {
        return config.public.DOWNLOAD_URL_IOS[locale.value.split('-')[1]];
    }
    return "";
})

const tutorialSliderDisplay = computed (()=> {
    return true
})
</script>